import React from 'react';
import './RadioButtonGroup.scss';
import RadioButton from 'src/components/RadioButtons/RadioButtons';

interface RadioOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface RadioButtonGroupProps {
  name: string;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  variant?: 'default' | 'primary' | 'success' | 'danger';
  size?: 'small' | 'default' | 'large';
  direction?: 'horizontal' | 'vertical';
}

const RadioButtonGroup = ({
  name,
  options,
  value,
  onChange,
  label,
  required = false,
  disabled = false,
  className,
  variant = 'default',
  size = 'default',
  direction = 'horizontal',
}: RadioButtonGroupProps) => {
  return (
    <div className={`radio-button-group ${className || ''}`}>
      {label && (
        <label className="radio-button-group__label">
          {label}
          {required && <span className="radio-button-group__required">*</span>}
        </label>
      )}
      <div
        className={`radio-button-group__options radio-button-group__options--${direction}`}
      >
        {options.map((option: RadioOption) => (
          <RadioButton
            key={option.value}
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={onChange}
            label={option.label}
            disabled={disabled || option.disabled}
            className={`radio-button--${variant} radio-button--${size}`}
          />
        ))}
      </div>
    </div>
  );
};

export default RadioButtonGroup;
